module.exports = __webpack_public_path__ + "img/SlopeSlide.9caf558b.png";